<template>
  <div>
    <Header></Header>
    <div class="bg-white">
      <div class="space-between edit-row area">
        <div>头像</div>
        <div>
          <!--
          <img v-else src="../assets/images/default-icon.png" alt="">-->
          <van-uploader :after-read="afterRead" >
             <img v-if="userInfo.headerImage" :src="userInfo.headerImage" alt="">
             <img v-else src="../assets/images/default-icon.png" alt="">
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="space-between edit-row">
        <div>昵称</div>
        <div class="color999">
          <!-- <div>{{userInfo.name}}</div> -->
          <input style="text-align:end" name="name" v-model="userInfo.name" />
        </div>
      </div>
      <div class="space-between edit-row">
        <div>性别</div>
        <!-- <div>{{array[sexIndex].text}}</div> -->
        <div class="color999" @click="showPopup">{{array[sexIndex].text}}</div>
      </div>
    </div>
    <div>
      <van-button type="primary" class="bg-green colorfff btn-confirm" @click="submit">保存</van-button>
    </div>
    <van-popup v-model="showSex" position="bottom" :style="{ height: '220px' }" :overlay="true">
      <van-picker show-toolbar :columns="array" @cancel="onCancel" @confirm="confirmChange" />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Picker } from "vant";
import { updateInfo } from "../api/api-parent";
import { getSignature } from "../api/api-common";
import Header from "../components/Header";
export default {
  name: "home",
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    })
  },
  components: {
    Header
  },
  data() {
    return {
      array: [{ id: 1, text: "男" }, { id: 2, text: "女" }],
      sexIndex: 0,
      showSex: false,
      signature:{}
    };
  },
  created() {
    this.sexIndex = this.userInfo.sex == 1 ? "0" : "1";
    console.log(this.userInfo)
  },
  methods: {
    submit(e) {
      console.log(this.userInfo)
      updateInfo(this.userInfo).then(res => {
        if (res.code == 200) {
          this.$store.dispatch("setUserInfo", this.userInfo);
          Toast.success("修改成功");
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    afterRead(option) {
     let file = option.file;
      getSignature().then((res)=>{
        if(res.code==200){
          this.signature=res.data
        }else{

        }

      }).then(()=>{
          const point = file.name.lastIndexOf(".");
          let suffix = file.name.substr(point);
          let fileName = file.name.substr(0, point);
          let date = Date.now();
          let fileNames = `${fileName}_${date}${suffix}`;
          let formData=new FormData();
          formData.append('accessid',this.signature.accessid);
          formData.append('policy',this.signature.policy);
          formData.append('signature',this.signature.signature);
          formData.append('expire',this.signature.expire);
          formData.append('OSSAccessKeyId',this.signature.OSSAccessKeyId);
          formData.append('key',this.signature.dir+fileNames);
          formData.append('file',file);
          formData.append('success_action_status',200);
          var _self = this
          $.ajax({
                url: _self.signature.host,
                type: 'post',
                data: formData,
                // async: false,
                cache: false,
                contentType:false,
                processData: false,
                success: function (data) {
                  console.log(_self.signature.host+"/"+_self.signature.dir+fileNames);
                  console.log(_self.userInfo);

                  _self.userInfo.headerImage = _self.signature.host+"/"+_self.signature.dir+fileNames;
                  console.log("++++");
                  console.log(_self.userInfo);
                  _self.$store.dispatch("setUserInfo",_self.userInfo);
                },
                error: function (data) {
                    console.log(data);
                }
            });

      })
    },
    showPopup() {
      this.showSex = true;
    },
    onCancel() {
      this.showSex = false;
    },
    confirmChange(picker, value, index) {
      this.sexIndex = value;
      this.userInfo.sex = value;
      this.showSex = false;
    },
    selectHead() {}
  }
};
</script>
<style lang="less" scoped>
.edit-row {
  padding: 11px 11px;
  margin: 0 15px 10px 15px;
  border-bottom: 1px solid rgba(226, 228, 232, 1);
  align-items: center;
}
.edit-row /deep/ .van-uploader__upload {
  width: 60px;
  height: 60px;
}
.edit-row input {
  border: none;
}
.edit-row img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.btn-confirm {
  position: fixed;
  bottom: 40px;
  width: 335px;
  left: 20px;
  color: #fff;
  font-size: 16px;
  border-radius: 22px;
}
.btn-confirm::after {
  border: none;
}
</style>
